/***
 * 创建人：但志强
 * 时间：2019-06-11
 * 描述: 工作台的待办面板 显示前五条
 * 更新说明:
 */
import { Component, OnInit, ComponentFactoryResolver, Input} from '@angular/core';
import { Router } from '@angular/router';
import { ProcessToDosService } from 'src/app/librarys/serves/public/process-to-dos.service';
import { SwJwtService } from 'src/app/librarys/serves/sw-jwt.service';
import { SwCreateModalComponentService } from 'src/app/librarys/serves/sw-create-modal-component.service';
import { BdpEnum } from 'src/app/areas/bdp/serves/bdp-enum';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { environment } from 'src/environments/environment';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { SystemIdService } from 'src/app/librarys/serves/public/system-id.service';
import { PlatformLocation } from '@angular/common';

/**
 * 工作台显示待办数据 默认显示前五条  sw-process-to-dos-table
 */
@Component({
  selector: 'sw-process-to-dos-table',
  templateUrl: './sw-process-to-dos-table.component.html',
  styleUrls: ['./sw-process-to-dos-table.component.css']
})
export class SwProcessToDosTableComponent implements OnInit {

  /**
   * @ignore
   * @param router
   * @param process
   */
  constructor( 
    private router: Router,
    private process:ProcessToDosService,
    private jwt: SwJwtService,
    private create:SwCreateModalComponentService,
    private cfr: ComponentFactoryResolver,
    private box: SwMassageBoxService, //消息服务
    private http: SwHttpClientService, //http 请求服务
    private systemId:SystemIdService,
    private Location: PlatformLocation,
    ) { }

  /**
   * @ignore
   * 数据表基础信息
   */
  infoList:any=[];
  
  isLoading:boolean=true;
  /**
  * 输入属性--是否待办列表字段有更多按钮,默认有
  */
  @Input() hasMore:boolean = true

  /**
   * @ignore
   */
  ngOnInit() {
    this.getTask();
    this.infoList = []  //之前的 this.getTask() 的里面虽然已经获取到了待办列表,但是工作台刷新时,没有刷新效果,所以下面重新将 infoList 清空, 再调用 this.process.oninitToDoToDos() 方法,重新调接口获取待办,然后由 getTask() 中刷新数据
    this.process.oninitToDoToDos()
  }

  /**
   * 查看待办内容
   * @ignore
   */
  outSelectData(event) {
    //点击查看内容跳转到具体审核页面 
    if(event.keyWord && event.businessId && event.url){
      let param = {
        businessKey: event.keyWord + ":" + event.businessId,
        procInstId:event.procInstId,
        projectId:event.projectId
      };
      //接下来判断是用tab页打开还是模态框打开
      if(event.openType == 1){  //tab页
        if(environment["enableModuleDeploy"]){
          //在不同的站点打开
          let arr = event.url.split('/')
          let functionCode = arr[1]  //要跳转的地址所属模块
          let sites:any = environment["moduleSites"]
          if(sites){
            sites = JSON.parse(sites)
            //如果要跳转的模块所属的站点就是当前地址栏的站点，就不用新开标签页
            let path = this.Location["location"].href
            let currentSite = path.split('#')[0].toLocaleLowerCase()
            let currentSiteFunctionCode
            //找到当前地址栏是属于哪个模块的站点地址
            for (const key in sites) {
              if(sites[key].indexOf(currentSite) > -1){
                currentSiteFunctionCode = key
              }
            }
            if(currentSiteFunctionCode == functionCode.toLocaleLowerCase()){
              //要跳转的地址与当前地址属于同一个站点，不开新标签页
              //如果打开方式是 tab页 的话
              if(event.url == '/oa/DynamicFormRender'){
                this.router.navigate(['/oa/DynamicFormRender/'+event['formId']], { queryParams: { Title: event.flowName, Operate: BdpEnum.SYS_PROCESS_VERIFY, data: JSON.stringify(param) } });
              }else{
                this.router.navigate([event.url], { queryParams: { Title: event.flowName, Operate: BdpEnum.SYS_PROCESS_VERIFY, data: JSON.stringify(param) } });
              }
            } else {  //打开新标签页
              let site = sites[functionCode.toLocaleLowerCase()]
              if(site){
                //看配置的站点信息中有没有参数
                let siteInfo = site.split('?')
                if(siteInfo.length >=2){  //如果有站点信息
                  site = siteInfo[0]    //单纯的站点,不带参数的
                }
                //获取到该模块的站点了，就可以拼接新地址，进行跳转操作
                let token = this.jwt.getlocaToken('token')
                let systemId = this.jwt.getlocaToken('systemId')
                let newUri
                let queryParams = JSON.stringify({ Title: event.flowName, Operate: BdpEnum.SYS_PROCESS_VERIFY, data: JSON.stringify(param) })
                if(event.url == '/oa/DynamicFormRender'){
                  newUri = site + '#/login?functionCode='+functionCode+'&RedirectUrl='+'/oa/DynamicFormRender/'+event['formId']+'&token='+token+'&systemId='+systemId+'&queryParams='+queryParams
                }else {
                  newUri = site + '#/login?functionCode='+functionCode+'&RedirectUrl='+event.url+'&token='+token+'&systemId='+systemId+'&queryParams='+queryParams
                }
                window.open(newUri)  //用不同的站点打开不同的模块
              } else {
                this.box.danger('缺少该模块站点配置项')
              }
            }
          } else {
            this.box.danger('缺少站点配置项')
          }
        } else {
          //如果打开方式是 tab页 的话
          if(event.url == '/oa/DynamicFormRender'){
            this.router.navigate(['/oa/DynamicFormRender/'+event['formId']], { queryParams: { Title: event.flowName, Operate: BdpEnum.SYS_PROCESS_VERIFY, data: JSON.stringify(param) } });
          }else{
            this.router.navigate([event.url], { queryParams: { Title: event.flowName, Operate: BdpEnum.SYS_PROCESS_VERIFY, data: JSON.stringify(param) } });
          }
        }
      } else if(event.openType == 2){ 
        //如果是用模态框打开
        let fact = this.cfr["_factories"]
        //对参数进行处理
        let modalParam = event.params ? JSON.parse(event.params) : {}
        let queryParams = { Title: event.flowName, Operate:BdpEnum.SYS_PROCESS_VERIFY, data: JSON.stringify(param) }
        let params = {param: modalParam,queryParams: queryParams}
        fact.forEach((value:any,key:any)=>{
          if(value.selector == event.url){
            this.create.createModal(key,params)
          }
        })
      } else {
        this.box.danger('没有打开方式'+event.openType)
      }
    }
  }

  

  /**
   * 获取所有待办信息前五条
   * @ignore
   */
  getTask() {
    //首先 查看 初始化化方法是否以及获取到数据
    if(this.process.processList){
      //如果获取到 则将数据赋值
      this.infoList =this.process.processList.records;
    }
    //这是是待办的订阅属性
    this.process.processUpdated.subscribe((val)=>{
      //如果接受到数据
      //重新获取数据
      this.isLoading=false;
      this.infoList = val.records;
    })
  }
  /**
   * 查看更多页面
   * @ignore
   */
  clickView(){
    this.router.navigate(['/oa/ToDoProcess'], {queryParams: {Title: '待办流程'}});
  }

}
